import type { ReactNode } from 'react';

/** One radio card in the Publish dialog (mock-up 05 §02). Teal marks the
 *  selected card, its radio and a "go" chip; nothing else is coloured. */
export default function PublishOption({
  name,
  value,
  selected,
  disabled,
  title,
  chip,
  chipGo,
  gloss,
  onSelect,
  children,
}: {
  name: string;
  value: string;
  selected: boolean;
  disabled?: boolean;
  title: string;
  chip: string;
  chipGo?: boolean;
  gloss: ReactNode;
  onSelect: () => void;
  children?: ReactNode;
}) {
  return (
    <div
      className={`block rounded-[12px] border px-4 pt-3.5 pb-3.5 mt-2.5 transition-colors ${
        selected
          ? 'border-accent shadow-[inset_0_0_0_0.5px_var(--color-accent)] bg-[color-mix(in_srgb,var(--color-accent)_4%,var(--color-card))]'
          : 'border-line bg-card'
      } ${disabled ? 'opacity-60' : ''}`}
    >
      <label className={`flex items-start gap-3 ${disabled ? 'cursor-not-allowed' : 'cursor-pointer'}`}>
        <input
          type="radio"
          name={name}
          value={value}
          checked={selected}
          disabled={disabled}
          onChange={onSelect}
          className="mt-[3px] w-4 h-4 accent-[var(--color-accent)] shrink-0"
        />
        <span className="min-w-0">
          <span className="flex items-center gap-2 flex-wrap text-[15px] font-semibold text-fg">
            {title}
            <span
              className={`font-mono text-[9.5px] tracking-[0.12em] uppercase font-semibold px-2 py-[3px] rounded-full border ${
                selected && chipGo
                  ? 'bg-accent/10 border-accent/35 text-accent'
                  : 'bg-elevated border-line text-muted'
              }`}
            >
              {chip}
            </span>
          </span>
          <span className="block text-[13px] text-muted mt-0.5 leading-[1.45]">{gloss}</span>
        </span>
      </label>
      {selected && children && (
        <div className="mt-3 ml-7 pt-3 border-t border-line">{children}</div>
      )}
    </div>
  );
}
